import { Component, signal, WritableSignal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { CommonModule } from '@angular/common';

import { BannerComponent } from '@core/components/layout/banner/banner.component';
import { HeaderComponent } from '../layout/header/header.component';
import { FooterComponent } from '@core/components/layout/footer/footer.component';
import { SidebarComponent } from '../layout/sidebar/sidebar/sidebar.component';

@Component({
  selector: 'base-app',
  templateUrl: './base-app.component.html',
  styleUrl: './base-app.component.scss',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    BannerComponent,
    CommonModule,
    FooterComponent,
    SidebarComponent,
  ],
})
export class BaseAppComponent {
  isSidebarClosed: WritableSignal<boolean> = signal<boolean>(false);

  setContentState(state: boolean): void {
    this.isSidebarClosed.set(state);
  }
}
